if(typeof window !== 'undefined' && window.document) {
    console.log("YES! SCRIPT RAN! iM HAPPEY!");
 }